export enum Role {
  SuperAdmin = "SuperAdmin",
  WorkspaceAdmin = "WorkspaceAdmin",
  DepartmentAdmin = "DepartmentAdmin",
  Broadcaster = "Broadcaster",
}
